export enum PStepState {
    disabled = 'disabled',
    active = 'active',
    completed = 'completed'
}
